import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { BackButtonStyled } from "./backButtonStyles";
import Modal from "../modal/Modal";

const BackButton = ({
  to = "/dashboard",
  label = "Volver",
  confirmMessage,
  onBeforeNavigate,
}) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  // Ejecuta la navegación (con su hook previo). Es lo que antes corría
  // directo cuando window.confirm devolvía true.
  const doNavigate = () => {
    if (onBeforeNavigate) onBeforeNavigate();
    navigate(to);
  };

  const handleClick = () => {
    // Sin mensaje de confirmación, navega directo como siempre.
    if (!confirmMessage) {
      doNavigate();
      return;
    }
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    doNavigate();
  };

  return (
    <>
      <BackButtonStyled type="button" onClick={handleClick}>
        <IoArrowBack />
        {label}
      </BackButtonStyled>

      <Modal
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirm}
        confirmText="Salir"
        cancelText="Cancelar"
      >
        <p>{confirmMessage}</p>
      </Modal>
    </>
  );
};

export default BackButton;
